import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../store/AuthContext";

export const PrivateRoute = ({ element, adminOnly, forgotPassword }) => {
  const { user, isAuthenticated } = useAuth();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const role = currentUser?.role;

  if (adminOnly) {
    if ((user || isAuthenticated) && role == "admin") {
      return element;
    } else {
      return <Navigate to="/dashboard" />;
    }
  } else {
    if (user || isAuthenticated) {
      return element;
    } else if (!user && forgotPassword) {
      return element;
    } else {
      return <Navigate to="/login" />;
    }
  }
};

